const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? '' 
  : 'http://localhost:3001';

class AuthService {
  async login(credentials) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(credentials),
      });

      const data = await response.json();

      if (!response.ok) {
        // Create enhanced error object with additional context
        const error = new Error(data.error || 'Login failed');
        error.field = data.field;
        error.canRetry = data.canRetry;
        error.statusCode = response.status;
        throw error;
      }

      return data;
    } catch (error) {
      // Re-throw enhanced error or create basic error for network issues
      if (error.field !== undefined) {
        throw error;
      } else {
        const enhancedError = new Error('Network error. Please check your connection and try again.');
        enhancedError.canRetry = true;
        enhancedError.field = 'network';
        throw enhancedError;
      }
    }
  }

  async logout() {
    try {
      const response = await fetch(`${API_BASE_URL}/api/logout`, {
        method: 'POST',
        credentials: 'include',
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Logout failed');
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  async checkAuthStatus() {
    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/status`, {
        credentials: 'include',
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error('Auth check failed');
      }

      return data;
    } catch (error) {
      return { authenticated: false };
    }
  }
}

export const authService = new AuthService();